import { getCookies, getQueryParams } from "@crystal/core";
function getMfServer(mfPath) {
  return {
    local: `http://localhost:8700${mfPath}`,
    stg: `https://stg.account-frontends.adidas.com${mfPath}`,
    prod: `https://account-frontends.adidas.com${mfPath}`,
    default: `https://dev.account-frontends.adidas.com${mfPath}`
  };
}
function getFlagContext(context) {
  const flagContext = {
    ...getCookies(),
    ...getQueryParams(),
    ...context
  };
  return flagContext;
}
export {
  getFlagContext,
  getMfServer
};
//# sourceMappingURL=utils.js.map
